

































































































































































































































































import Vue from 'vue'
import firebase from 'firebase'
import 'firebase/auth'
import { userAvatarImage } from '../../helper/constants'
import UserAvatar from '@/components/common/UserAvatar.vue'
import { adminMode } from '../../helper/permission.helper'
import { getMobileTheme } from '../../helper'
import { getFeatureFlag, getContactId } from '@/services'
import axios from 'axios'
import config from '../../config'

export default Vue.extend({
  components: {
    UserAvatar
  },
  props: {
    logo: {
      type: String
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    alignment: {
      type: String,
      default: 'between'
    },
    backCallback: {
      type: Function
    }
  },
  data() {
    return {
      open: false,
      openSettings: false,
      headerRoot: {
        'product-overview': 'navigation-header',
        'post-overview': 'lesson-navigation-header'
      },
      headerContainer: {
        'product-overview': 'header',
        'post-overview': 'lesson-header'
      },
      username: ''
    }
  },
  computed: {
    brandLogoUrl(): string {
      return this.logo || this.$store.state.logoUrl
    },
    userImage(): string {
      return this.$store.getters.userAvatar || userAvatarImage
    },
    isAdmin() {
      return adminMode()
    },
    libraryPath(): string {
      const featureFlag: any = getFeatureFlag()
      return featureFlag?.libraryV2 ? 'library-v2' : 'library'
    }
  },
  mounted() {
    this.getUsername()
  },
  methods: {
    signOut() {
      this.$cookies.remove('cat')
      if (localStorage) {
        try {
          localStorage.removeItem('cat')
        } catch (error) {
          // patch
        }
      }
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: 'login' })
        })
    },
    async getUsername() {
      const contactId = getContactId()
      if (!contactId) {
        throw new Error(`Invalid contact id ${contactId}`)
      }

      const { data } = await axios.get(
        config.mainServerUrl + `/contact/membership/${contactId}`
      )
      this.username = data.fullName
    },
    getMobileTheme
  }
})
